module.exports = __webpack_public_path__ + "img/active_0.e1cf2a7b.png";